import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import LayoutInner from '../../../../layouts/main/components/layout-inner/layout-inner';
import CustomButton from '../../../../shared/components/buttons/custom-button/custom-button';
import { PlusIcon } from '../../../../shared/icons/plus-icon';
import { useAppDispatch } from '../../../../store/hooks';
import AuthGuard from '../../../auth/components/auth-guard/auth-guard';
import { closeAlerts, openModal } from '../../../ui/store/ui-slice';
import { UserPermissionType } from '../../../user/models/user-permission-type';
import ClientGroupsContent from '../../components/client-groups-content/client-groups-content';
import { clientGroupFormModalId, clientGroupsAlertId } from '../../constants/constants';

const ClientGroups = (): JSX.Element => {
  const { t } = useTranslation(['client-groups', 'common']);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(closeAlerts());
  }, [dispatch]);

  return (
    <AuthGuard permission={UserPermissionType.ViewGroups}>
      <Helmet>
        <title>{t('menu.clientGroups', { ns: 'common' })}</title>
      </Helmet>
      <LayoutInner
        alertId={clientGroupsAlertId}
        headerActionButton={
          <CustomButton
            type="primaryLight"
            onClick={() => dispatch(openModal(clientGroupFormModalId))}
            icon={<PlusIcon />}
          >
            {t('newGroup')}
          </CustomButton>
        }
      >
        <ClientGroupsContent />
      </LayoutInner>
    </AuthGuard>
  );
};

export default ClientGroups;
